let $win = $(window);
let winH = $win.height();

function animate(winST = 0) {
  $('.animations').each(function() {
    if (winST + winH * 0.95 > $(this).offset().top) {
      let animClass = $(this).data('animation');

      if (!$(this).hasClass('animated')) {
        $(this).addClass('animated');
        $(this).addClass(animClass);
      }
    }
  });
}

module.exports = {
  animate
};



// WEBPACK FOOTER //
// ../assets/js/animate.js